import { breakpoints } from 'style'
import styled from 'styled-components'

export const FriendRowContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 45px;
  border-bottom: 1px solid #f2f2f2;

  .role-cell {
    display: flex;
    align-items: center;
  }

  h6 {
    margin-bottom: 0;
    font-size: 15px;
    &.friend-name {
      min-width: 100px;
    }
  }
  .icon-invite {
    display: flex;
    justify-content: center;
    svg:hover {
      opacity: 0.7;
    }
  }
  .role-icon {
    display: none;
    @media (min-width: ${breakpoints.desktop}px) {
      display: block;
    }
  }

  .friend-role {
    span {
      font-size: 15px;
    }

    &.role-uneditable {
      @media (min-width: ${breakpoints.desktop}px) {
        margin-left: 42px;
      }
    }

    .role-name {
      margin-left: 1rem;
    }
  }
  @media (max-width: 767px) {
    .friend-role {
      text-decoration: underline dotted blue;
      text-underline-offset: 3px;
    }
  }
`
